module.exports = __webpack_public_path__ + "static/NotoSans-BoldItalic.subset-08390b7c9575b7e9dd0e960e7412a568.woff";